var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5891 0.548886C38.9992 -0.116525 37.9457 -0.199478 37.2714 0.424156C34.6588 2.66984 32.257 5.03998 29.8549 7.49337C27.4952 9.94705 25.1775 12.4419 22.9441 15.0201C19.6572 18.8872 16.4967 22.921 13.547 27.0795L2.84359 15.727C2.33801 15.1863 1.49528 15.0201 0.820975 15.4358C0.0202515 15.8932 -0.232509 16.8914 0.231039 17.6812C0.231039 17.6812 10.4288 35.0217 10.8502 35.7702C11.2717 36.4771 12.1988 37.6 14.095 37.6C15.9492 37.6 16.9603 36.5189 17.5505 35.396C18.1825 34.2317 23.8294 23.9188 27.4954 18.4713C29.3073 15.7267 31.2878 13.0653 33.2685 10.4456C35.2911 7.82575 37.398 5.24761 39.5473 2.83574L39.5893 2.79426C40.1369 2.08737 40.1369 1.17248 39.589 0.548575L39.5891 0.548886Z",
    fill: "#12B76A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/TickIcon.0b684313e2a386c7506d38a1b4dc196c.svg";
export { ForwardRef as ReactComponent };